import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1xd9ogml: FaireBrandEntity = {
  token: "b_1xd9ogml",
  type: "brand",
  name: "Parks Project",
  avatarUrl:
    "https://cdn.faire.com/fastly/e0c0596ee9fcecaf08a7cf5478cd7f0e30512118e688284e5699e2aaea1037d2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2753d02e80f78ecaad090bf7ba67d1b7c536eaff73d0f8d6bf3d13c9f0f0db66.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e0c0596ee9fcecaf08a7cf5478cd7f0e30512118e688284e5699e2aaea1037d2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2753d02e80f78ecaad090bf7ba67d1b7c536eaff73d0f8d6bf3d13c9f0f0db66.png",
  location: "Marina Del Rey , CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "We Give Back.  Leave It Better Than You Found It™. \n\nWe protect and preserve parklands for generations to come by educating, advocating, volunteering, and engaging park supporters in conservation. To date, Parks Project has contributed over $2,800,000 to help fund vital projects in parks around the US.\n\nB-Corp Certified.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:00.152Z",
    importedBy: "entity-db-cli",
  },
};
